import React, { useState } from 'react';
import Button from '../shared/Button';

// THE GUEST EMAIL SENDER CARD — one card for both owners of a sending domain: the chain (Chain Settings › MCP) and a
// hotel (Hotel › Products › MCP), which overrides the chain's (code-pipelines integrations/mcpservice.js,
// mcp/settings.js forHotel: hotel → chain → hconnect's). The owner's screen supplies the calls; this card only
// draws the domain, its DNS records and the three actions.
//
//   domain      the owner's own senderDomain view, or null
//   fallback    for a hotel: { label, address } of what it sends from without its own (the chain's domain or
//               hconnect's) — shown so the override reads as one
//   canEdit     the server's answer (canEditChain / canEdit)
//   busy, run   the owner's busy key and act(key, fn)
//   onStart({ domain, fromLocal }), onCheck(), onRemove()

const when = (v) => (v ? new Date(v).toLocaleString() : '—');

export default function SenderDomainCard({ domain: sd, fallback, canEdit, busy, run, onStart, onCheck, onRemove, ownerLabel = 'chain' }) {
  const [form, setForm] = useState({ domain: '', fromLocal: 'reservations' });

  return (
    <div className="mcps-card">
      <div className="mcps-card-head"><h3>Guest email sender</h3>
        {sd && <span className={`mcps-pill mcps-pill-${sd.status.toLowerCase()}`}>{sd.status}</span>}</div>
      {fallback && (
        <p className="mcps-meta">
          {sd && sd.status === 'VERIFIED'
            ? <>This hotel&rsquo;s own domain is in use — it overrides {fallback.label}.</>
            : <>Without its own verified domain this hotel sends from {fallback.label}{fallback.address ? <> (<strong>{fallback.address}</strong>)</> : null}.</>}
        </p>
      )}
      {sd ? (
        <>
          <p className="mcps-meta">Guest emails go from <strong>{sd.address}</strong> once the domain is verified — until then, and
            whenever it stops being verified, from {fallback ? fallback.label : <>hconnect&rsquo;s address</>}. Add these records to the domain&rsquo;s DNS:</p>
          <table className="mcps-table">
            <thead><tr><th>Type</th><th>Name</th><th>Value</th></tr></thead>
            <tbody>{sd.records.map(r => <tr key={r.name}><td>{r.type}</td><td className="mcps-mono">{r.name}</td><td className="mcps-mono">{r.value}</td></tr>)}</tbody>
          </table>
          <p className="mcps-meta">Last checked {when(sd.lastCheckedAt)}.</p>
          {canEdit && <div className="mcps-actions">
            <Button variant="secondary" disabled={!!busy} onClick={() => run('check', onCheck)}>
              {busy === 'check' ? 'Checking…' : 'Check now'}</Button>
            <Button variant="danger" disabled={!!busy} onClick={() => run('remove', onRemove)}>
              {busy === 'remove' ? 'Removing…' : 'Stop using this domain'}</Button>
          </div>}
        </>
      ) : (
        <>
          <p className="mcps-meta">
            {fallback
              ? <>To send this hotel&rsquo;s guest emails from its own domain instead, enter it here and publish the DNS records it gives you.</>
              : <>Guest emails go from hconnect&rsquo;s address with replies to the hotel. To send from the {ownerLabel}&rsquo;s own domain,
                enter it here and publish the DNS records it gives you. A hotel can set its own, which overrides this one.</>}
          </p>
          {canEdit && <div className="mcps-grid">
            <label>Domain<input value={form.domain} placeholder="mail.yourhotel.com" onChange={e => setForm(d => ({ ...d, domain: e.target.value }))} /></label>
            <label>Address before the @<input value={form.fromLocal} onChange={e => setForm(d => ({ ...d, fromLocal: e.target.value }))} /></label>
            <div><Button variant="primary" disabled={!!busy || !form.domain.trim()} onClick={() => run('domain', () => onStart(form))}>
              {busy === 'domain' ? 'Starting…' : 'Set up'}</Button></div>
          </div>}
        </>
      )}
    </div>
  );
}
